import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { Tab, Tabs } from '@blueprintjs/core';
import VocByCorpus from './VocByCorpus.js';
import VocComparison from './VocComparison.js';
import VocAll from './VocAll.js';
import VocMultivar from './VocMultivar.js';
import { H2 } from '@blueprintjs/core';
import { Tooltip2, Classes } from '@blueprintjs/popover2';
import EnhancedSingleSelect from '../../../common/EnhancedSingleSelect';


class Voc extends React.PureComponent {

  state = {
    //selectedTabId: Object.keys(this.props.stats.byCorpus)[0],  // select first corpus by default
    selectedTabId: "Global" 
  }

  handleTabChange = (tabId) => {
    this.setState({ selectedTabId: tabId });
    //  this trick is to cope with the react-apex-chart show problem
    window.dispatchEvent(new Event('resize'));
  }

  render() {
    const { stats, t, subCorpora, queryHistory, onSelectResult} = this.props;
    const lexicoStats=stats.lexicoStats;
    // as lexicoStats are not computed for all the corpora, display is optional
    const displayLexicoStats= (typeof lexicoStats !== "undefined" 
      && typeof lexicoStats.featureStats !== "undefined"
      && typeof lexicoStats.nbForms !== "undefined"
      && typeof lexicoStats.lexicalDensity !== "undefined"
      && typeof lexicoStats.maxSpanSize !== "undefined"
      && typeof lexicoStats.repet4cat !== "undefined"
      && typeof lexicoStats.dist4cat !== "undefined"
    );

    const tabs = [];
    const cats = [];
    // extract the cat list to feed the select field
    for (var i=0;i<stats.cat['__global__'].length;i++) {
      cats.push(stats.cat['__global__'][i][0]);
    }

    const navSelect=  
      <div style={{display:'flex'}}>
        <EnhancedSingleSelect
            label={t('query')}
            name='query'  // name is also used to make the input's `id`
            options={queryHistory}
            value={queryHistory[0]}
            onChange={onSelectResult}
        />
      </div>;

    const statGlobal = <VocByCorpus
                            name='global' 
                            lemmaStats={stats.lemma['__global__']} 
                            catStats={stats.cat['__global__']}
                            patternStats={stats.patternStats?stats.patternStats['__global__']:null}
                            cats={cats}
                            size={stats.size['__global__']}
                            vocSize={stats.vocSize['__global__']}
                            spec={stats.spec}
                            nbDocs={stats.nbDocs?stats.nbDocs['__global__']:0}
                            nbParas={stats.nbParas?stats.nbParas['__global__']:0}
                            nbCls={stats.nbCls?stats.nbCls['__global__']:0}
                            nbSents={stats.nbSents?stats.nbSents['__global__']:0}
                            featureStats={displayLexicoStats?lexicoStats.featureStats['__global__']:null}
                            nbForms={displayLexicoStats?lexicoStats.nbForms['__global__']:null}
                            lexicalDensity={displayLexicoStats?lexicoStats.lexicalDensity['__global__']:null}
                            averageLength={displayLexicoStats?lexicoStats.averageLength['__global__']:null}
                            //repet4cat={lexicoStats?lexicoStats.repet4cat['__global__']:null}
                            maxSpanSize={displayLexicoStats?lexicoStats.maxSpanSize:null}
                            STTR={displayLexicoStats && lexicoStats.STTR ?lexicoStats.STTR['__global__']:null}
                            TTRSpanSize={displayLexicoStats?lexicoStats.TTRSpanSize:null}
                            displayLexicoStats={displayLexicoStats}
                            performSearch={this.props.performSearch}
                        />;
    const tab = <Tab key='Global' id='Global' title={t('global')} panel={statGlobal} />;
    tabs.push(tab);
    
    // const allStats = [];
    // generate the indidual stat pages (sub-corpus or partition) if necessary
    for (i=0;i<subCorpora.length;i++) {
      const subCorpus=subCorpora[i];
      let title=subCorpus;
      let displayName=false;
      if (subCorpora.length>16) {
        displayName=true;
        title=" "+(i+1).toString();
        title=title.slice(-2);
      }
      //console.log("diffStats",subCorpus,stats.diffStats[subCorpus]);
      const stat = <VocByCorpus
                      name={subCorpus}
                      displayName={displayName}
                      lemmaStats={stats.lemma[subCorpus]} 
                      catStats={stats.cat[subCorpus]}
                      patternStats={stats.patternStats?stats.patternStats[subCorpus]:null}
                      cats={cats}
                      diffStats={stats.diffStats ? stats.diffStats[subCorpus]:null} 
                      size={stats.size[subCorpus]}
                      vocSize={stats.vocSize[subCorpus]}
                      spec={stats.spec} 
                      nbDocs={stats.nbDocs?stats.nbDocs[subCorpus]:0}
                      nbParas={stats.nbParas?stats.nbParas[subCorpus]:0}
                      nbCls={stats.nbCls?stats.nbCls[subCorpus]:0}
                      nbSents={stats.nbSents?stats.nbSents[subCorpus]:0}
                      featureStats={displayLexicoStats?lexicoStats.featureStats[subCorpus]:null}
                      nbForms={displayLexicoStats?lexicoStats.nbForms[subCorpus]:null}
                      lexicalDensity={displayLexicoStats?lexicoStats.lexicalDensity[subCorpus]:null}
                      averageLength={displayLexicoStats?lexicoStats.averageLength[subCorpus]:null}
                      repet4cat={displayLexicoStats?lexicoStats.repet4cat[subCorpus]:null}
                      dist4cat={displayLexicoStats?lexicoStats.dist4cat[subCorpus]:null}
                      maxSpanSize={displayLexicoStats?lexicoStats.maxSpanSize:null}
                      STTR={displayLexicoStats && lexicoStats.STTR ?lexicoStats.STTR[subCorpus]:null}
                      TTRSpanSize={displayLexicoStats?lexicoStats.TTRSpanSize:null}
                      useLemma4Repet={displayLexicoStats?lexicoStats.useLemma4Repet:null}
                      displayLexicoStats={displayLexicoStats}
                      performSearch={this.props.performSearch}                     
                />;
      const tab = <Tab key={subCorpus} id={subCorpus} title={title} panel={stat} >
                    {displayName && <Tooltip2 content={subCorpus} className={Classes.TOOLTIP2_INDICATOR} placement="bottom" >…</Tooltip2>}
                  </Tab>;
      tabs.push(tab);
    }

    if (subCorpora.length>0) {
      const vocAll = <VocAll
          subCorpora={subCorpora}
          lemmaStats={stats.lemma} 
          catStats={stats.cat}
          cats={cats}
          diffStats={stats.diffStats ? stats.diffStats :{}} 
          size={stats.size}
          vocSize={stats.vocSize}
          spec={stats.spec} 
          nbDocs={stats.nbDocs?stats.nbDocs:[]}
          nbParas={stats.nbParas?stats.nbParas:[]}
          nbCls={stats.nbCls?stats.nbCls:[]}
          nbSents={stats.nbSents?stats.nbSents:[]}
          featureStats={displayLexicoStats?lexicoStats.featureStats:[]}
          nbForms={displayLexicoStats?lexicoStats.nbForms:[]}
          lexicalDensity={displayLexicoStats?lexicoStats.lexicalDensity:[]}
          averageLength={displayLexicoStats?lexicoStats.averageLength:[]}
          repet4cat={displayLexicoStats?lexicoStats.repet4cat:[]}
          dist4cat={displayLexicoStats?lexicoStats.dist4cat:[]}
          maxSpanSize={displayLexicoStats?lexicoStats.maxSpanSize:0}
          STTR={displayLexicoStats && lexicoStats.STTR?lexicoStats.STTR:[]}
          TTRSpanSize={displayLexicoStats?lexicoStats.TTRSpanSize:0}
          useLemma4Repet={displayLexicoStats?lexicoStats.useLemma4Repet:[]}
          displayLexicoStats={displayLexicoStats}                       
      />;
      const tabVocAll = <Tab key="vocAll" id="vocAll" title={t('subCorpusComparison')} panel={vocAll} />;
      tabs.push(tabVocAll);

      const comparison= <VocComparison
                          nbDocs={stats.nbDocs}
                          nbParas={stats.nbParas}
                          nbCls={stats.nbCls}
                          nbSents={stats.nbSents}
                          size={stats.size}
                          vocSize={stats.vocSize}
                          STTR={lexicoStats && lexicoStats.STTR?lexicoStats.STTR:[]}
                          lexicalDensity={lexicoStats?lexicoStats.lexicalDensity:null}
                          averageLength={lexicoStats?lexicoStats.averageLength:null}
                        />

      const tabComp = <Tab key='Comparison' id='Comparison' title={t('chartComparison')} panel={comparison} />;
      tabs.push(tabComp);

      const multivar= <VocMultivar
                        subCorpora={subCorpora}
                        lemmaData={stats.lemma}
                        catData={stats.cat}
                        cats={cats}
                        session_id={this.props.session_id}
                      />

      const  tabMultivar = <Tab key='Multivar' id='Multivar' title={t('multivarStats')} panel={multivar} />;
      tabs.push(tabMultivar);
    }

    return (
      <>
        {navSelect}
        <H2>{t('vocabulary')}</H2>
        <Tabs onChange={this.handleTabChange} selectedTabId={this.state.selectedTabId} renderActiveTabPanelOnly={true}	>
          {tabs}
        </Tabs>
      </>
    );
  }
}

Voc.propTypes = {
  stats: PropTypes.object,
  subCorpora: PropTypes.array,
  performSearch: PropTypes.func,
  session_id: PropTypes.string,
};

export default withTranslation()(Voc);
